import { render, staticRenderFns } from "./DuplicatePrevYearDataConfirmModal.vue?vue&type=template&id=7cc87bea&scoped=true&"
import script from "./DuplicatePrevYearDataConfirmModal.vue?vue&type=script&lang=ts&"
export * from "./DuplicatePrevYearDataConfirmModal.vue?vue&type=script&lang=ts&"
import style0 from "./DuplicatePrevYearDataConfirmModal.vue?vue&type=style&index=0&id=7cc87bea&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cc87bea",
  null
  
)

export default component.exports